import { type GenericVehicleDetails } from '@finn/ua-vehicle';
import { FUEL, getDefaultTerm } from '@finn/ua-vehicle/ssr';
import { type SeoHeaderData } from '@finn/ui-cosmic';
import { replaceStrKeys, twoDecimalPlaces } from '@finn/ui-utils/ssr';
import get from 'lodash/get';

export const getVehicleMinPrice = (vehicle: GenericVehicleDetails) => {
  const longestTerm = getDefaultTerm(vehicle);
  const price =
    get(
      vehicle,
      `downpayment_prices.available_price_list.b2c_${longestTerm}`
    ) || 0;

  return twoDecimalPlaces(price);
};

export const defaultMileageOption = 850;

export const getVehicleSeoHeader = (
  seoHeader: SeoHeaderData,
  vehicle: GenericVehicleDetails
) => {
  const titleTemplate = get(seoHeader, 'metadata.title', '');
  const descriptionTemplate = get(seoHeader, 'metadata.description', '');
  const seoData = {
    brand: get(vehicle, 'brand.id') || '',
    model: get(vehicle, 'model') || '',
    label: get(vehicle, 'label') || '',
    fuel: get(vehicle, 'fuel') || '',
    color: get(vehicle, 'color.specific') || '',
    carType: get(vehicle, 'cartype') || '',
    cheapest_price: getVehicleMinPrice(vehicle),
    equipment_line: get(vehicle, 'equipment_line') || '',
    model_year: get(vehicle, 'model_year') || '',
  };

  const actualTitle = replaceStrKeys(titleTemplate, seoData);
  const actualDescription = replaceStrKeys(descriptionTemplate, seoData);

  return {
    ...seoHeader,
    metadata: {
      ...seoHeader?.metadata,
      og_image: { url: get(vehicle, 'picture.url', '') },
      title: actualTitle,
      description: actualDescription,
      og_description: actualDescription,
      og_title: actualTitle,
    },
  };
};

export const isPlugInHybridVehicle = (fuel: string) =>
  fuel === FUEL.PlugInHybrid;
